import Vue from 'vue';
import VueRouter from 'vue-router';

import { layoutRoutes } from '@/components/repsol-layout/repsol-layout.routes';
import { layoutLoginRoutes } from '@/components/repsol-layout-login/repsol-layout-login.component.routes';
import { notFoundRoutes } from '@/views/not-found/not-found.routes';
import i18n from '@/plugins/i18n';
import { env } from '@/env';
import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';

// Need to change and delete view and components
interface InterfaceRoute {
  meta: { title: string; moduleAccess: string };
}

const DEFAULT_ROUTE: InterfaceRoute = {
  meta: { title: '', moduleAccess: '' },
};

const updateDocumentTitle = (route: any): void => {
  const resolvedRoute = route || router.currentRoute;
  const matchedRoutes = Array.isArray(resolvedRoute?.matched) ? resolvedRoute.matched : [];

  const routeWithTitle = matchedRoutes.find((matchedRoute: any) => matchedRoute?.meta?.title);
  const title = routeWithTitle?.meta?.title || '';

  if (!title) {
    return;
  }

  const titleApp = `${env.appName} (${env.environment})`;
  document.title = `${titleApp?.replace(/\s\|.*/, '')} | ${i18n.t(title)}`;
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/login' },
    layoutLoginRoutes,
    layoutRoutes,
    notFoundRoutes,
  ],
});

router.beforeEach(async (to, from, next) => {
  const moduleAccess = to.meta ? to.meta.moduleAccess : '';

  if (moduleAccess) {
    const userIdentity = (await (store.state as any).userIdentity
      .userIdentity) as UserIdentityModel;
    if (userIdentity && userIdentity.modulos)
      if (
        !userIdentity ||
        !userIdentity.modulos ||
        userIdentity.modulos[moduleAccess] == undefined
      ) {
        console.log("Redirect login", moduleAccess, userIdentity.modulos);
        next({ name: 'Layout Login' });
        return;
      }
  }

  updateDocumentTitle(to);

  next();
});

if ((i18n as any)?.vm) {
  (i18n as any).vm.$watch('locale', () => {
    updateDocumentTitle(router.currentRoute);
  });
}

export default router;
